var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert"},[_c('div',{staticClass:"el-icon-ali-jinggao blue",staticStyle:{"margin-right":"8px"}}),_c('div',[_vm._v(" 通知：因企业微信客服账号正在变更中，平台客服二维码已更新，有问题请联系"),_c('span',{staticClass:"blue",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setServicepopupvisible({visible:true})}}},[_vm._v("新平台客服。")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }